import React, { useState } from "react";
import DOMPurify from "dompurify";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import useBreakpoint from "../../../../utils/useBreakpoint";
import GroundTourModal from "./GroundTourModal";

const ICONS = "/iceholidays-assets/images/icons";

interface Props {
  highlight?: string;
}

export default function HighlightCard({ highlight }: Props) {
  const [open, setOpen] = useState(false);
  const isMobile = useBreakpoint();

  if (!highlight) return null;

  const body = (
    <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{DOMPurify.sanitize(highlight)}</Markdown>
  );

  return (
    <section className="ground-tour-show-v2__highlight">
      <img
        className="ground-tour-show-v2__highlight-decoration"
        src={`${ICONS}/highlight-card-decoration.png`}
        alt=""
        aria-hidden="true"
      />

      <div className="ground-tour-show-v2__highlight-header">
        <h2 className="ground-tour-show-v2__highlight-title">
          Highlight
          <img
            className="ground-tour-show-v2__highlight-wave"
            src={`${ICONS}/icon-highlight-wave.svg`}
            alt=""
            aria-hidden="true"
          />
        </h2>

        <button type="button" className="ground-tour-show-v2__highlight-viewall" onClick={() => setOpen(true)}>
          {isMobile ? "View all" : "View All"}
        </button>
      </div>

      <div className="ground-tour-show-v2__highlight-body">{body}</div>

      <GroundTourModal open={open} onClose={() => setOpen(false)} title="Highlight" isMobile={isMobile}>
        <div className="ground-tour-show-v2__highlight-modal-body">{body}</div>
      </GroundTourModal>
    </section>
  );
}
